import { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Paper,
  Box,
  Stack,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Logo from "../assets/Yaazh_logo.png";
import { ApiServices } from "../utils/ApiService";
import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { login } from '../authSlice';
import { jwtDecode } from 'jwt-decode';
import { createKeyFromPassword, deriveKeyFromPassword, encryptObject, decryptObject } from '../utils/cryptoClient'
import { useNotification } from "../context/NotificationContext";
// ✅ Optional: import background image
import backgroundImage from "../assets/login-bg.png"; // Replace with your actual image file

export default function LoginPage() {
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const { connectSocket } = useNotification();

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    try {
      if (userName && password) {
        const res = await ApiServices.post('user/login', {
          userName,
          password
        });
        if (res?.status === 200) {
          enqueueSnackbar("Login Success !", { variant: "success" });
          const userData = res?.data;
          // const payload =  jwtDecode(userData?.token)
          // dispatch(login(payload));
          localStorage.setItem("user", JSON.stringify(userData));
          localStorage.setItem("isLoggedIn", "true");
          connectSocket(userData?.id); // Connect to socket after successful login
          // debugger
          // // on successful login:
          // // Option 1: derive from user password (prompt once, or use login password)
          // const { key, salt } = await createKeyFromPassword(password);
          // // encrypt
          // const encrypted = await encryptObject(userData, key);
          // // store encrypted + salt in localStorage
          // localStorage.setItem('user.enc', JSON.stringify(encrypted));
          // localStorage.setItem('user.salt', salt);

          // // later (app init): to read back
          // const objSalt = localStorage.getItem('user.salt');
          // if (objSalt) {
          //   // ask user for the same password (or derive key via some secure flow)
          //   const key = await deriveKeyFromPassword(password, objSalt);
          //   const encrypted = JSON.parse(localStorage.getItem('user.enc') || '{}');
          //   const obj = await decryptObject(encrypted, key);
          //   console.log(obj)
          //   // use obj (id, name, token...)
          // }

          if (userData?.role === "Processor") {
            navigate("/processor-dashboard");
          } else if (userData?.role === "MOD Executive") {
            navigate("/expenses");
          } else if (userData?.role === "Private Processor") {
            navigate("/processor-dashboard");
          } else {
            navigate("/dashboard");
          }
        } else {
          enqueueSnackbar("Login failed.", { variant: "error" });
        }
      }
    } catch (error) {
      const err = error?.response?.data?.message || "Login failed.";
      enqueueSnackbar(err, { variant: "error" });
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        px: 2,
      }}
    >
      <Paper
        elevation={5}
        sx={{
          padding: 4,
          maxWidth: 400,
          width: "100%",
          textAlign: "center",
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(255, 255, 255, 0.9)",
        }}
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="center"
          mb={3}
          sx={{ backgroundColor: "#131d38", p: 1, borderRadius: 1 }}
        >
          <img
            src={Logo}
            alt="Yaazh Logo"
            style={{ width: 50, height: 50, objectFit: "contain" }}
          />
          <Typography
            variant="h5"
            fontWeight="bold"
            color="#fff"
            sx={{ ml: '0px !important' }}
          >
            Yaazh Legal Associates
          </Typography>
        </Stack>

        <Box component="form" noValidate autoComplete="off" onSubmit={handleLogin}>
          <TextField
            fullWidth
            margin="normal"
            label="Phone Number or Email"
            required
            value={userName}
            onChange={(e) => setUserName(e.target.value)}
          />

          <TextField
            fullWidth
            margin="normal"
            label="Password"
            required
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            sx={{ mt: 2 }}
            disabled={!userName || !password}
          >
            Login
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
